// Barra inferior (celular): o contador do "Carrinho" (link pra /cart) acompanha o carrinho pelo evento
// cartUpdate do pubsub do Dawn, com o número também em texto pra leitor de tela.
// "Meu veículo" e o destaque ficam no ds-veiculo-ui.js.
const textoLeitor = (n) => (n === 0 ? "Carrinho vazio" : n === 1 ? "Carrinho, 1 item" : `Carrinho, ${n} itens`);

// A barra é buscada a cada atualização (o editor do tema pode recriar a seção).
function pintar(n) {
  const nav = document.querySelector("[data-ds-bottom-nav]");
  if (!nav) return;
  const contador = nav.querySelector("[data-ds-cart-count]");
  const leitor = nav.querySelector("[data-ds-cart-sr]");
  if (contador) {
    contador.textContent = n > 99 ? "99+" : String(n);
    contador.hidden = n === 0;
  }
  if (leitor) leitor.textContent = textoLeitor(n);
}

// Só a resposta do pedido mais recente vale (duas mudanças seguidas: a primeira resposta é descartada).
let pedido = 0;
async function buscar() {
  const meu = ++pedido;
  try {
    const r = await fetch(`${window.routes?.cart_url ?? "/cart"}.js`, { headers: { Accept: "application/json" } });
    if (!r.ok) return;
    const carrinho = await r.json();
    if (meu === pedido && Number.isFinite(carrinho?.item_count)) pintar(carrinho.item_count);
  } catch (e) {
    /* mantém o número anterior */
  }
}

function atualizar(evt) {
  const n = evt?.cartData?.item_count;
  if (Number.isFinite(n)) {
    pedido++; // invalida qualquer busca em andamento, o dado do evento é o mais novo
    pintar(n);
  } else {
    buscar();
  }
}

// subscribe e PUB_SUB_EVENTS são globais do Dawn (pubsub.js e constants.js, carregados antes)
if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
  subscribe(PUB_SUB_EVENTS.cartUpdate, atualizar);
}
